/**
 * Delivery dates, re-worded on the shop's day.
 *
 * A Shipping & Returns rule set to "Delivery dates" is worded in Liquid
 * (snippets/shipping-delivery-text.liquid) on the day Shopify rendered the
 * page — and a cached page can be a day behind. snippets/shipping-policy-text
 * .liquid wraps such a text in <span data-delivery-dates data-min data-max
 * data-free data-price data-tz>; this re-words every one from today in the
 * shop's time zone (data-tz) — the day checkout, the order record and the
 * email count from too — and again whenever the cart drawer or a variant
 * switch puts new ones in the page. No zone (a mirror saved before it carried
 * one): today on this device.
 *
 * With data-ship (the shipping time), Shopify's manual delivery dates: a
 * business-day order before 12 pm shop time starts that day, any other the next
 * business day; hand-off after `ship` business days; data-min–max transit
 * days after that. Empty data-ship: transit straight from today, no cutoff.
 *
 * Same wording as birch-order-management src/shipping-policy/shipping-core.mjs
 * deliveryText: business days Monday to Friday, no holidays; "Free Delivery
 * Thu, Oct 22", "Free Delivery Oct 22 – 27", "Free Delivery Oct 30 – Nov 3",
 * "Delivery …" when charged, "$9.99 Delivery …" with a price.
 */
(function () {
  var SELECTOR = '[data-delivery-dates]';
  var DAY_MS = 86400000;
  var CUTOFF_HOUR = 12; // as in Shopify: orders from 12 pm shop time start the next business day
  var WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  /**
   * Now in the shop's zone (else on this device): the day as a UTC midnight,
   * so stepping days never meets a clock change, and the hour for the cutoff.
   */
  function now(timeZone) {
    var at = new Date();
    if (timeZone) {
      try {
        var parts = new Intl.DateTimeFormat('en-US', { timeZone: timeZone, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' }).formatToParts(at);
        var get = function (type) {
          for (var i = 0; i < parts.length; i++) if (parts[i].type === type) return parseInt(parts[i].value, 10);
          return NaN;
        };
        var t = Date.UTC(get('year'), get('month') - 1, get('day'));
        if (t === t) return { day: t, hour: get('hour') % 24 };
      } catch (e) {
        // An unknown zone: fall through to this device's clock.
      }
    }
    return { day: Date.UTC(at.getFullYear(), at.getMonth(), at.getDate()), hour: at.getHours() };
  }

  function addBusinessDays(t, n) {
    for (var left = n; left > 0; ) {
      t += DAY_MS;
      var wd = new Date(t).getUTCDay();
      if (wd !== 0 && wd !== 6) left--;
    }
    return new Date(t);
  }

  function price(cents) {
    var dollars = Math.floor(cents / 100);
    var rest = cents % 100;
    return '$' + dollars + (rest ? '.' + (rest < 10 ? '0' : '') + rest : '');
  }

  /** The text for one span, or '' when its data is unusable (the Liquid text then stays). */
  function wording(el) {
    var min = parseInt(el.getAttribute('data-min'), 10);
    var max = parseInt(el.getAttribute('data-max'), 10);
    var cents = parseInt(el.getAttribute('data-price'), 10);
    var free = el.getAttribute('data-free') !== 'false';
    if (!(min >= 1)) return '';
    if (!(max >= min)) max = min;
    var clock = now(el.getAttribute('data-tz'));
    var start = clock.day;
    var ship = el.getAttribute('data-ship');
    var offset = 0;
    if (ship !== null && ship !== '' && parseInt(ship, 10) >= 0) {
      var wd = new Date(start).getUTCDay();
      offset = parseInt(ship, 10) + (wd === 0 || wd === 6 || clock.hour >= CUTOFF_HOUR ? 1 : 0);
    }
    var from = addBusinessDays(start, min + offset);
    var to = addBusinessDays(start, max + offset);
    var md = function (d) { return MONTHS[d.getUTCMonth()] + ' ' + d.getUTCDate(); };
    var when =
      from.getTime() === to.getTime()
        ? WEEKDAYS[from.getUTCDay()] + ', ' + md(from)
        : from.getUTCMonth() === to.getUTCMonth() && from.getUTCFullYear() === to.getUTCFullYear()
          ? md(from) + ' – ' + to.getUTCDate()
          : md(from) + ' – ' + md(to);
    var label = free ? 'Free Delivery' : cents > 0 ? price(cents) + ' Delivery' : 'Delivery';
    return label + ' ' + when;
  }

  function update() {
    var spans = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < spans.length; i++) {
      var text = wording(spans[i]);
      // Only on a change: rewriting the same text would wake the observer for nothing.
      if (text && spans[i].textContent !== text) spans[i].textContent = text;
    }
  }

  update();

  // The cart drawer and the variant picker swap markup in; re-word once per
  // batch, and only when an added element carries a delivery span.
  var queued = false;
  new MutationObserver(function (mutations) {
    if (queued) return;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1 && (node.matches(SELECTOR) || node.querySelector(SELECTOR))) {
          queued = true;
          requestAnimationFrame(function () {
            queued = false;
            update();
          });
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // A tab left open past midnight.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') update();
  });
})();
